const DEFAULT_PREFIX = "MC";

export const createWalletNameWithPrefix = (
  walletName: string,
  prefix: string = DEFAULT_PREFIX
) => {
  if (!walletName) return null;

  return `${prefix}_${walletName}`;
};
